import styled from 'styled-components';
import { colorPrimary, colorWhite } from '@tds/core-colours';

export const Button = styled.button`
  cursor: pointer;
  background: none;
  border: none;
  text-decoration: underline;
  white-space: nowrap;
`;

export const ButtonWrapper = styled.div`
  margin: 24px 0;
  width: 100%;
  display: flex;
  justify-content: flex-end;
  white-space: nowrap;
`;

export const ExportButton = styled.button`
  color: ${colorWhite};
  background-color: ${colorPrimary};
`;

export const SearchWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  flex-direction: row;
  padding: 16px 0;
  @media screen and (max-width: 992px) {
    justify-content: flex-start;
  }
`;
